import React from 'react';
import { useRecoilValue } from 'recoil';
import { getDownloadLink } from '../../Shares/CommonUtil';
import { cdnUrlConfig } from '../../Utils/atoms';

/**
 * 댕냥룸 콘테스트 이벤트 2023-01월 프로모션 페이지
 */
const PetHomePromotionJanuary = () => {
    const cdnUrl = useRecoilValue(cdnUrlConfig);
    const IMG_URL = `${cdnUrl}/BigglzEvent`;

    return (
        <div id="wrap">
            <div className="container">
                <div className="content PetHome January">
                    <div className="visual">
                        <div className="month">1월</div>
                        <h1>
                            <img src={`${IMG_URL}/images/room/january/tit_january.png`} alt="/images/room/january/tit_january.png" />
                        </h1>
                        <p>댕냥룸 콘테스트에 나의 댕냥룸 자랑하고 <span>올리브영 기프트카드</span> 받아가자~!</p>
                    </div>
                    <div className="event-info detail">
                        <div className="tit-area">
                            <h2>
                                <span>이벤트 상세 안내</span>
                            </h2>
                        </div>
                        <ul className="info-list">
                            <li>
                                <div className="tit-info">기간</div>
                                <div className="txt">2023년 01월 1일 ~ 2023년 01월 31일</div>
                            </li>
                            <li>
                                <div className="tit-info">당첨대상</div>
                                <div className="txt">
                                    설날 아이템으로 댕냥룸을 꾸미고,<br /><span>좋아요</span> 를 가장 많이 받은 참가자
                                </div>
                            </li>
                            <li>
                                <div className="tit-info">발표일</div>
                                <div className="txt">2023년 2월 7일</div>
                            </li>
                        </ul>
                    </div>
                    <div className="event-info product">
                        <div className="tit-area">
                            <h2>경품<br />안내</h2>
                        </div>
                        <div className="product-box">
                            <div className="product-area">
                                <div className="tit-area">
                                    <h3>월간보상</h3>
                                </div>
                                <ol>
                                    <li>
                                        <div className="photo">
                                            <figure>
                                                <img src={`${IMG_URL}/images/room/img_rewards1.png`} alt="/images/room/img_rewards1.png" />
                                                <figcaption>올리브영 기프트카드 15만원</figcaption>
                                            </figure>
                                        </div>
                                        <div className="name"><span className="rank">1등</span> 올리브영 기프트카드 15만원</div>
                                    </li>
                                    <li>
                                        <div className="photo">
                                            <figure>
                                                <img src={`${IMG_URL}/images/room/img_rewards2.png`} alt="/images/room/img_rewards2.png" />
                                                <figcaption>올리브영 기프트카드 10만원</figcaption>
                                            </figure>
                                        </div>
                                        <div className="name"><span className="rank">2등</span> 올리브영 기프트카드 10만원</div>
                                    </li>
                                    <li>
                                        <div className="photo">
                                            <figure>
                                                <img src={`${IMG_URL}/images/room/img_rewards3.png`} alt="/images/room/img_rewards3.png" />
                                                <figcaption>올리브영 기프트카드 5만원</figcaption>
                                            </figure>
                                        </div>
                                        <div className="name"><span className="rank">3등</span> 올리브영 기프트카드 5만원</div>
                                    </li>
                                </ol>
                            </div>
                            <div className="product-area">
                                <div className="tit-area">
                                    <h3>주간보상</h3>
                                </div>
                                <ol>
                                    <li>
                                        <span className="rank">1등</span>
                                        <i></i>
                                        젤리 300
                                    </li>
                                    <li>
                                        <span className="rank">2등</span>
                                        <i></i>
                                        젤리 100
                                    </li>
                                    <li>
                                        <span className="rank">3등</span>
                                        <i></i>
                                        젤리 50
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="event-info howto">
                        <div className="tit-area">
                            <h2>참여<br />방법</h2>
                        </div>
                        <ol>
                            <li>
                                <div className="num">1</div>
                                <div className="txt">펫홈 화면에서<br /> 댕냥룸 콘테스트 아이콘 클릭</div>
                                <div className="img">
                                    <figure>
                                        <img src={`${IMG_URL}/images/room/january/img_guide1.png`} alt="/images/room/january/img_guide1.png" />
                                    </figure>
                                    <figcaption>펫홈 화면에서 댕냥룸 콘테스트 아이콘 클릭</figcaption>
                                </div>
                            </li>
                            <li>
                                <div className="num">2</div>
                                <div className="txt">하단 콘테스트 참여하기</div>
                                <div className="img">
                                    <figure>
                                        <img src={`${IMG_URL}/images/room/january/img_guide2.png`} alt="/images/room/january/img_guide2.png" />
                                    </figure>
                                    <figcaption>하단 콘테스트 참여하기</figcaption>
                                </div>
                            </li>
                            <li>
                                <div className="num">3</div>
                                <div className="txt">마이룸에서 댕냥룸을<br /> 캡처해서 업로드</div>
                                <div className="img">
                                    <figure>
                                        <img src={`${IMG_URL}/images/room/january/img_guide3.png`} alt="/images/room/january/img_guide3.png" />
                                    </figure>
                                    <figcaption>마이룸에서 댕냥룸을 캡처해서 업로드</figcaption>
                                </div>
                            </li>
                        </ol>
                    </div>
                    <div className="cautionary">
                        <dl>
                            <dt>확인해주세요!</dt>
                            <dd>동일 좋아요 수가 존재할 경우 먼저 높은 좋아요를 달성한 사람이 더 높은 순위로 설정됩니다.</dd>
                            <dd>참가자 미달 시 당첨자가 없을 수 있습니다.</dd>
                            <dd>당첨자가 회원 탈퇴 등으로 인해 확인이 불가할 경우 당첨이 취소됩니다.</dd>
                            <dd>주말 포함 7일 이내 연락이 없을 시 당첨이 취소됩니다.</dd>
                            <dd>1월 댕냥룸 콘테스트는 설날 아이템으로 댕냥룸을 꾸미고, 좋아요를 가장 많이 받은 참가자 중 1,2,3등이 경품을 받으실 수 있습니다.</dd>
                            <dd>당첨 경품 수령 관련 상세 내용은 당첨 발표 시 안내될 예정이며, 안내에 따른 추가 정보 회신이 필요합니다.</dd>
                            <dd>해당 이벤트는 앱스토어 또는 구글 플레이스토어 등과 무관합니다.</dd>
                        </dl>
                    </div>
                    <a href={getDownloadLink()} target="_blank" rel="noopener noreferrer" className='btn-download'>
                        <i></i>앱 다운로드 하러가기
                    </a>
                </div>
            </div>
        </div>
    );
}

export default PetHomePromotionJanuary;